export default __webpack_public_path__ + "static/media/logonuevo.5f3cbee6.png";